import { Component, OnInit, Input } from '@angular/core'
import { HttpClient, HttpResponse, HttpErrorResponse } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { throwError } from 'rxjs'

@Injectable()
export class UiUtil {

    constructor() {
    }


    public static parseURL(url: string) {
        var parser = document.createElement('a'),
            searchObject: any = {},
            queries, split, i
        // Let the browser do the work
        parser.href = url
        // Convert query string to object
        queries = parser.search.replace(/^\?/, '').split('&')
        for (i = 0; i < queries.length; i++) {
            split = queries[i].split('=')
            searchObject[split[0]] = split[1]
        }
        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            port: parser.port,
            pathname: parser.pathname,
            search: parser.search,
            searchObject: searchObject,
            hash: parser.hash
        }
    }

    public static getUrlParameter(paramName: string) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'), sParameterName, i

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=')

            if (sParameterName[0] === paramName) {
                return sParameterName[1] === undefined ? true : sParameterName[1]
            }
        }
        return null
    }

    /**
     * FixMe Do better logic. Fix Nnid length and use that length to identify the rocde
     * @returns
     */
    public static getLastPartOfUrl() {
        var pathName = UiUtil.parseURL(window.location.href).pathname
        return this.getLastPart(pathName)
    }

    public static getLastPart(pathName: string) {
        var pathTokens = pathName.split("/")

        if (pathTokens.length == 2) {
            return pathTokens[1]
        }
        if (pathTokens.length > 3) {
            return pathTokens[3]
        }
        if (pathTokens.length > 2) {
            return pathTokens[2]
        }

        return null
    }


}
